import React, { FC } from 'react'

const TextEditorPreview: FC<{ children: string }> = (props) => {
  const contentRef = React.useRef<HTMLDivElement | null>(null)

  React.useEffect(() => {
    // Lấy phần tử template
    const template = document.createElement('template')
    template.innerHTML = `
      <link rel="stylesheet" href="css/quill.snow.css">
      <div class='ql-editor'>${props.children}</div>
    `

    // Tạo shadow DOM và chèn nội dung từ template
    if (contentRef.current) {
      const shadowRoot = contentRef.current.shadowRoot || contentRef.current.attachShadow({ mode: 'open' })

      shadowRoot.innerHTML = '' // Reset nội dung cũ
      shadowRoot.appendChild(template.content.cloneNode(true))
    }
  }, [props.children])

  return (
    <>
      <div ref={contentRef}></div>
    </>
  )
}

export default TextEditorPreview
